import { render, staticRenderFns } from "./TableSelector.vue?vue&type=template&id=4672a78b&scoped=true&"
import script from "./TableSelector.vue?vue&type=script&lang=js&"
export * from "./TableSelector.vue?vue&type=script&lang=js&"
import style0 from "./TableSelector.vue?vue&type=style&index=0&id=4672a78b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672a78b",
  null
  
)

export default component.exports